
import { IPage } from '../api/types/IPage';

export class Page implements IPage {

  public static DefaultMaxItems: number = 100;

  public startIndex: number;
  public maxItems: number;

  public constructor(page: IPage = { startIndex: 0, maxItems: Page.DefaultMaxItems }) {
    this.startIndex = page.startIndex;
    this.maxItems = page.maxItems;
  }

  public from(startIndex: number): Page {
    return new Page({ startIndex, maxItems: this.maxItems });
  }

  public size(maxItems: number): Page {
    return new Page({ startIndex: this.startIndex, maxItems });
  }

  /*
   Up to but including the given index
   */
  public to(endIndex: number): Page {
    return new Page({ startIndex: this.startIndex, maxItems: Math.max(0, endIndex - this.startIndex) });
  }

  public next(maxItems: number = this.maxItems): Page {
    return new Page({ startIndex: this.startIndex + maxItems, maxItems });
  }
}
